import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";
import {
  selectDominantSpeaker,
  selectIsConnectedToRoom,
  useHMSStore,
} from "@100mslive/react-sdk";
import { VolumeOneIcon } from "@100mslive/react-icons";
import {
  Box,
  config as cssConfig,
  Flex,
  styled,
  Text,
  textEllipsis,
  useTheme,
} from "@100mslive/roomkit-react";
import { LiveHodoContext } from "../../../contexts/LiveHodoContext";
import { LANG_CODES } from "../../../lang";
import { useLogo } from "../AppData/useUISettings";
import { getImageURL, isStreamingKit } from "../../common/utils";

export const SpeakerTag = () => {
  const dominantSpeaker = useHMSStore(selectDominantSpeaker);
  return dominantSpeaker && dominantSpeaker.name ? (
    <Flex
      align="center"
      justify="center"
      css={{
        flex: "1 1 0",
        color: "$on_surface_high",
        "@md": { display: "none" },
      }}
    >
      <VolumeOneIcon />
      <Text
        variant="md"
        css={{ ...textEllipsis(200), ml: "$2" }}
        title={dominantSpeaker.name}
      >
        {dominantSpeaker.name}
      </Text>
    </Flex>
  ) : (
    <></>
  );
};

const LogoImg = styled("img", {
  maxHeight: "$14",
  p: "$2",
  w: "auto",
  "@md": {
    maxHeight: "$12",
  },
});

export const Logo = () => {
  const { t, i18n } = useTranslation();

  const { themeType } = useTheme();
  const logo = useLogo();
  const isMobile = useMedia(cssConfig.media.md);
  const isConnected = useHMSStore(selectIsConnectedToRoom);

  const {
    stateCtx: { circleRoomDetail, twlMeetRoom },
  } = useContext(LiveHodoContext);

  const [headerInfo, setHeaderInfo] = useState({});

  useEffect(() => {
    if (!circleRoomDetail && !twlMeetRoom) return;

    let infoRaw = {
      name: circleRoomDetail?.name || twlMeetRoom?.name || "",
      logo:
        circleRoomDetail?.logo ||
        circleRoomDetail?.room_logo ||
        (twlMeetRoom?.clinic?.avatar
          ? getImageURL(twlMeetRoom?.clinic?.avatar)
          : "") ||
        "",
    };

    setHeaderInfo(infoRaw);
  }, [circleRoomDetail, twlMeetRoom]);

  const circleMultiLang = useMemo(() => {
    const langValue = LANG_CODES[i18n.language];
    const langData =
      headerInfo?.circle_language?.find(item => item?.Lang === langValue) || {};
    return langData;
  }, [headerInfo, t]);

  if (isConnected && isMobile && isStreamingKit()) {
    return null;
  }

  return (
    <Flex align="center">
      {headerInfo && headerInfo?.logo ? (
        <LogoImg
          src={headerInfo?.logo}
          alt={circleMultiLang?.name || headerInfo?.name || "Live HODO"}
          width={132}
          height={40}
        />
      ) : (
        <LogoImg
          src={
            logo ||
            (themeType === "dark"
              ? require("../../../images/hodologo_256x256.png")
              : require("../../../images/hodologo_256x256.png"))
          }
          alt={circleMultiLang?.name || headerInfo?.name || "Live HODO"}
          width={132}
          height={40}
          css={{ marginRight: 8 }}
        />
      )}
      {/* {headerInfo && (
        <Box>
          <Text variant="h6" css={{ ...textEllipsis(960), fontSize: 16 }}>
            {circleMultiLang?.name || headerInfo?.name}
          </Text>
        </Box>
      )} */}
    </Flex>
  );
};
